export const slackObjSelector = state => state.slack || {};

export const slackIntegrationsSelector = state =>
  slackObjSelector(state).integrations;
